import { useMemo } from "react"

export const useEnv = () => {

  const environment = useMemo(() => {
    return (process.env.REACT_APP_ENV ?? 'dev') as 'dev' | 'test' | 'prod'
  }, [])

  const isDevEnv = useMemo(() => {
    return environment === "dev"
  }, [environment])

  return { environment, isDevEnv }
}